import Carga from '@/model/resource/Carga'
import ClientNotificationResponseSchema from '@/schema/ClientNotificationResponse.schema'

export default class ClientNotificationResponse extends Carga {
    readonly $name: string = 'ClientNotificationResponse'
    readonly $endpoint: string = '/user/indicador/client-notification'

    get $schema() {
        return ClientNotificationResponseSchema(this)
    }
}
